<template>
    <div id="Ep-pop" class="My_popup" style="display: block;">
        <div class="My_popup_wrap">
            <span class="My_popup_close" href="#" @click.prevent="closeClickHandler" style="cursor: pointer;">닫기</span>
            <div class="My-popup-title">{{ promiseInfo.val2 }}</div>
            <div class="ep-photo pink-line">
                <span class="flag pink">공약</span>
                <div class="pop-picture-wrap">
                    <swiper class="swiper" :options="swiperOption">
                        <swiper-slide v-for="(image, i) in promiseInfo.dataFiles" :key="i">
                            <ul class="slides">
                                <img :src="getImgUrl(image)" @error="altImgUrl" :alt="image.otxtFlnm">
                            </ul>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                </div>
            </div>
            <div class="My-popup-content">
                <div class="ep-detail">
                    <div class="ep-list bdr-bm">
                        <ul>
                            <li>
                                <span>사업명</span>
                                <span>{{ promiseInfo.val2 }}</span>
                            </li>
                            <li>
                                <span>사업소개</span>
                                <span>{{ promiseInfo.val15 }}</span>
                            </li>
                            <li>
                                <span>사업기간</span>
                                <span>{{ promiseInfo.val6 }}</span>
                            </li>
                            <li>
                                <span>총괄부서</span>
                                <span>{{ promiseInfo.val3 }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="pop_title">추진경과</div>
                    <div class="pop_table bdr-bm">
                        <table class="tb-list02" summary="추진경과">
                            <caption>추진경과 내역</caption>
                            <colgroup>
                                <col style="width:20%">
                                <col style="width:80%">
                            </colgroup>
                            <tr>
                                <th>진도율</th>
                                <td class="alignL" v-html="$options.filters.newLineToBr(promiseInfo.val10)+'%'"></td>
                            </tr>
                            <tr>
                                <th>진도율상태</th>
                                <td class="alignL" v-html="$options.filters.newLineToBr(promiseInfo.val11)"></td>
                            </tr>
                            <tr>
                                <th>정책개요</th>
                                <td class="alignL" v-html="$options.filters.newLineToBr(promiseInfo.val5)"></td>
                            </tr>
                            <tr>
                                <th>정책목표</th>
                                <td class="alignL" v-html="$options.filters.newLineToBr(promiseInfo.val4)"></td>
                            </tr>
                            <tr>
                                <th>추진실적</th>
                                <td class="alignL" v-html="$options.filters.newLineToBr(promiseInfo.val7)"></td>
                            </tr>
                            <tr>
                                <th>향후계획</th>
                                <td class="alignL" v-html="$options.filters.newLineToBr(promiseInfo.val8)"></td>
                            </tr>
                        </table>
                    </div>
                    <!-- <RelevantBizList :promiseInfo="promiseInfo" :diagName="diagName" /> 
                    <div class="bdr-bm"></div> -->
                    <!-- <div class="pop_title">여론동향</div>
                    <NewsDataList :paramObj="paramObj" /> -->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { $WC } from '@/conf/common.const.js';
import RelevantBizList from '@/views/biz/RelevantBizList.vue';
import NewsDataList from '@/components/NewsDataList.vue';

export default {
    name: 'promiseCardWin',
    props: {
        paramObj: {
            type: Object,
            required: true
        },

    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: {
                    delay: $WC.FIVE_SEC_INTERVAL,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            },
            selectedPromiseCategoryCode: "A",
            promiseBusinessDatas: [],
            diagName: '공약'
        }
    },
    created() {
        this.$store.dispatch('FETCH_PROMISE_INFO', this.paramObj)
    },
    computed: {
        promiseInfo() {
            return this.$store.getters.getPromiseInfo;
		},
		autoPlaying() {
            return this.promiseInfo.dataFiles.length == 1 ? false : true;
        }
    },
    methods: {
        closeClickHandler() {
            this.$emit("close-promise-info-win");
        },
        getImgUrl(image) {
            if (typeof image.comnFlSqno !== 'undefined') {
                return $WC.apiBaseURL + '/data/image/' + image.comnFlSqno;
            } else {
                return $WC.cp + 'images/none_img.png';
            }
        },
        altImgUrl(event) {
            event.target.src = $WC.cp + 'images/none_img.png';
        },
    },
    components: {
        RelevantBizList,
        NewsDataList,
    }
}
</script>